export default "__VITE_ASSET__Ds$DbYHE__"